import { render, staticRenderFns } from "./AddEditAttributesModal.vue?vue&type=template&id=0a32c531&"
import script from "./AddEditAttributesModal.vue?vue&type=script&lang=js&"
export * from "./AddEditAttributesModal.vue?vue&type=script&lang=js&"
import style0 from "./AddEditAttributesModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports